import { render, staticRenderFns } from "./EditCommunityOrganizationModal.vue?vue&type=template&id=59c95ac0&scoped=true&"
import script from "./EditCommunityOrganizationModal.vue?vue&type=script&lang=ts&"
export * from "./EditCommunityOrganizationModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditCommunityOrganizationModal.vue?vue&type=style&index=0&id=59c95ac0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c95ac0",
  null
  
)

export default component.exports